export enum CompetitionTableColumns {
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  CompetitionId = "competitionId",
  ExternalId = "externalId",
  AbbreviationLocal = "abbreviationLocal",
  AbbreviationLatin = "abbreviationLatin",
  AgeGroup = "ageGroup",
  Images = "images",
  League = "league",
  InternationalReference = "internationalReference",
}
